import { ReactComponent as StarFillIcon } from '../../../../assets/icons/ic_star.svg';
import IconButton from '../atom/IconButton';
import dots from '../../../../assets/icons/ic_three_dots.svg';
import useComponentVisible from '../../../../utilities/hooks/useComponentVisible';
import ProfileImage from '../../common/ProfileImage';
import moment from 'moment';
import useRatingPhrase from '../../../../utilities/hooks/UseRatingPhrase';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/ic_eye.svg';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';

const ProviderReviewsCompact = ({item,onProviderReviewsClicked}) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const { getPhrase } = useRatingPhrase();
    const dictionary = useDictionary();
    const onContextClicked = () => {
		setIsComponentVisible(!isComponentVisible);
	};
    const getDate = (date) => {
        if(date) {
            return moment(date* 1000).format('MMM DD, YYYY')
        }
    }
    return (
        <div className="review-card" onClick={()=>onProviderReviewsClicked(item)}>
            <div className="d-flex flex-direction-column" style={{gap:16, marginBottom:16}}>
                <div className='d-flex'>
                    <div className='d-flex' style={{gap:12}}>
                        <ProfileImage name={item.customer.name} photo={item.customer.avatar} size={{ width: 40, height: 40,fontSize: 14, lineHeight: 16 }}/>
                        <div className='review-compact-details'>
                            <div className="provider-booking-customer-name truncate">{item.customer.name}</div>
                            <div className="provider-customers-number" style={{opacity:0.6}}># {item.booking.display_id}</div>
                            <div className="provider-customers-number" style={{opacity:0.6}}>{item.experience.title}</div>
                        </div>
                    </div>
                    <div className="flex-filler" />
                    <div className="provider-customers-actions-wrapper d-flex justify-center">
                        <IconButton onClickIcon={onContextClicked} activeState={isComponentVisible} styleObject={{width: '32px',height: '32px',borderRadius: '6px'}}>
                            <img src={dots} />
                        </IconButton>

                        <div ref={ref} className="provider-customers-action-menus-container">
                            {isComponentVisible ? (
                                <>
                                    <div className="provider-customers-actions-container">
                                        <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onProviderReviewsClicked(item)}}>
                                            <EyeIcon />
                                            <div>{dictionary.view}</div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="review-text">{getPhrase(parseInt(item.rating))}</div>
            </div>
            <div className="review-footer">
                <div className="provider-customers-duration d-flex" style={{gap:4,opacity:0.6}}>
                    <div>
                        {parseFloat(item.rating).toFixed(1)}
                    </div>
                    <StarFillIcon width={12} height={12} style={{ color: '#22264C', padding:'1px 0px' }} />
                </div>
                <span className="provider-customers-number" style={{opacity:0.6}}>{getDate(item.created_at)}</span>
            </div>
        </div>
    )
}

export default ProviderReviewsCompact;